import React from 'react';
import API from "../../Services/API";
import {toast} from "react-toastify";
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import {LuClipboardList} from "react-icons/lu";
import {BsChevronLeft, BsShop} from "react-icons/bs";
import {FaCubes, FaRegStar} from "react-icons/fa";
import {TbDoorExit, TbReportAnalytics} from "react-icons/tb";

import {IoWarningOutline} from "react-icons/io5";
import {useNavigate, useParams} from "react-router-dom";
import {GiHamburgerMenu} from "react-icons/gi";
import LogoPic from "../../Assets/Images/logo.png";
import {BiSolidSelectMultiple} from "react-icons/bi";
import {LiaUserEditSolid} from "react-icons/lia";
import StarRating from "./StarRating";

const currencyFormat = Intl.NumberFormat('en-US');

function Home() {
     const navigate = useNavigate();
    const {id} = useParams();

    const [isLoaded, setIsLoaded] = React.useState(false);
    const [user, setUser] = React.useState([]);
    const [orders, setOrders] = React.useState([]);
    const [orderCount, setOrderCount] = React.useState([]);
    const [status, setStatus] = React.useState(id ? parseInt(id) : 1);

    React.useEffect(() => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        if (!token) {
            window.location.replace('/login')
        }
        const params = {
            processFor: 'Suppliers',
            vendor_id: window.localStorage.getItem("vendor"),
            orderBy: 'id',
            orderType: 'desc',

        }
        API.getVendor(params)
            .then((response) => {

            })
            .catch((error) => {
                setTimeout (() => {
                    navigate(`/vendor/select`)
                },400)
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });

        API.getUserInfo()
            .then((response) => {
                setIsLoaded(true);
                  setUser(response.data.user);
                for(let v in response.data.user.vendor) {
                    if(response.data.user.vendor[v].id === parseInt(window.localStorage.getItem("vendor"))) {
                        setOrderCount(response.data.user.vendor[v].ordersCount)
                    }
                }
                for(let v in response.data.user.vendor) {
                    if(response.data.user.vendor[v].id === parseInt(window.localStorage.getItem("vendor"))) {
                        setOrderCount(response.data.user.vendor[v].ordersCount)
                    }
                }

                if(response.data.user.vendor.length) {
                    if(!window.localStorage.getItem("vendor")) {
                        window.localStorage.setItem("vendorTitle", response.data.user.vendor[0].title);
                        window.localStorage.setItem("vendor", response.data.user.vendor[0].id);
                    }

                    setIsLoaded(false);
                    const params = {
                        count: 40,
                        page: 1,
                        list: 1,
                        orderBy: 'created_at',
                        orderType: 'desc',
                        processFor: 'Suppliers',
                        status_id:  status,
                        vendor_id: window.localStorage.getItem("vendor")
                    }

                    API.getOrders(params)
                        .then((response) => {
                            setOrders(response.data);
                            setIsLoaded(true);
                        })
                        .catch((error) => {
                            if(error.response) {
                                toast.error(error.response.data.message);
                            }
                            else {
                                toast.error(error.message);
                            }
                        });


                }
            })
            .catch((error) => {
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });




    }, [status]);

    const onExitClick = () => {
        localStorage.clear();
        document.cookie = "auth=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        window.location.replace("/")
    }


    return (
        <React.Fragment>
            <Toast/>
            {
                !isLoaded && <Loading/>
            }

            <section className="container-fluid  rtl">
                <div className="row bg-primary-color py-3 ps-0" id='menu-button'>
                    <div className="col-6 text-end "
                         onClick={() => {
                             window.document.getElementById('side-menu').style.display ='block';
                         }}
                    >
                        <GiHamburgerMenu className='text-white fw-bold text-big-3' />

                    </div>
                    <div className="col-6 text-start">
                        <img src={LogoPic} alt="پخش من" className="rounded " width='30'/>

                    </div>
                </div>
                <div className="row main-box">
                    <div className="col-md-3 p-5 " >
                        <div className="row " id='side-menu'>
                            <div className="col-12">
                                <div className="row">
                                    <div className="col-12 text-center pt-3">
                                        {
                                            isLoaded && user?.vendor?.map (vendor  => {
                                                if(vendor.id === parseInt(window.localStorage.getItem("vendor")) ) {
                                                    return (
                                                        <img src={vendor.cover_photo} alt="Cover" className='w-100 mt-3 company-cover-photo' />
                                                    )
                                                }
                                                return '';
                                            } )
                                        }

                                        <div className='text-primary-color my-4 text-small-2 mt-3'>
                                            {user.name}
                                            &nbsp;

                                            {user.surname}
                                            &nbsp;

                                            (
                                            {
                                                window.localStorage.getItem("vendorTitle")
                                            }
                                            )

                                        </div>
                                    </div>
                                    <div className="col-12 item "
                                         id={status === 1 ? 'active' : ''}
                                    onClick={ () => {
                                        setStatus(1)
                                        if(window.screen.width < 500) {
                                            window.document.getElementById('side-menu').style.display ='none';
                                        }
                                    }}
                                    >
                                        <LuClipboardList className='mx-2'/>
                                                    سفارش های تازه ثبت شده
                                        {
                                            orderCount > 0 &&  <span className='badge badge-pill badge-primary bg-danger mx-2 text-small-3 '>
                                                                    {orderCount}
                                                                </span>
                                        }
                             

                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         id={status === 2 ? 'active' : ''}
                                         onClick={ () => {
                                             setStatus(2)

                                             if(window.screen.width < 500) {
                                                 window.document.getElementById('side-menu').style.display ='none';
                                             }
                                         }}
                                    >
                                        <LuClipboardList className='mx-2'/>
                                        سفارش های جاری
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         id={status === 3 ? 'active' : ''}
                                         onClick={ () => {
                                             setStatus(3)
                                             if(window.screen.width < 500) {
                                                 window.document.getElementById('side-menu').style.display ='none';
                                             }
                                         }}
                                    >
                                        <LuClipboardList className='mx-2'/>
                                        سفارش های تمام شده
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/products`)}
                                    >
                                        <FaCubes className='mx-2'/>
                                        مدیریت کالاها
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/vendor/manage`)}
                                    >
                                        <BsShop className='mx-2'/>
                                        مدیریت اطلاعات مجموعه
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/vendor/select`)}
                                    >
                                        <BiSolidSelectMultiple className='mx-2'/>
                                        انتخاب مجموعه فعال
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/edit-profile`)}
                                    >
                                        <LiaUserEditSolid className='mx-2'/>
                                        ویرایش حساب کاربری
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/reports`)}
                                    >
                                        <TbReportAnalytics className='mx-2'/>
                                        گزارش فاکتورهای فروش
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
     <div className="col-12 item "
                                         onClick={() => navigate(`/product-reports`)}

                                    >
                                        <TbReportAnalytics className='mx-2'/>
                                        گزارش  فروش کالا
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>

                                    <div className="col-12 item "
                                         onClick={() => navigate(`/wallet`)}
                                    >
                                        <TbReportAnalytics className='mx-2'/>
                                        گزارش صورت عملکرد
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>

                                    <div className="col-12 item "
                                    onClick={onExitClick}
                                    >
                                        <TbDoorExit className='mx-2'/>
                                        خروج از حساب کاربری
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-9 pt-md-5 main-part mt-md-5">


                        <div className="row pb-5 px-2">
                            <div className="col-12 page-title text-center pb-4 mb-5 border-bottom fw-bold text-muted">
                              لیست سفارش های
                                &nbsp;
                                {
                                    status === 1 ? 'جدید' : (status === 2 ? ' جاری' : (status === 3 ? ' تمام شده' : 'رد شده'))
                                }
                            </div>
                            <div className="col-12">
                                <table className="table text-small-1  table-striped bg-white order-table">
                                    <thead className='text-small-2'>
                                    <tr className="bg-primary-color text-white text-center small-1 rounded ">
                                        <td>
                                            مشتری
                                        </td>
                                        <td>
                                            آدرس
                                        </td>
                                        <td>
                                            تاریخ  ثبت
                                        </td>
                                        <td>
                                            کد پیگیری
                                        </td>

                                        <td>
                                            مبلغ
                                        </td>
                                    </tr>
                                    </thead>
                                    <tbody className='text-small-1'>
                                    {
                                        orders.map (order => {
                                            return (
                                                <tr className="text-center" key={order.id}
                                                    onClick={() => navigate(`/order/${order.id}`)}
                                                >
                                                    <td>
                                                        {order.user.name}
                                                        &nbsp;
                                                        {order.user.surname}
                                                        &nbsp;
                                                        -
                                                        &nbsp;
                                                        {order.user.username}
                                                        <div>
                                                            {
                                                                order.cash_discount_percent > 0 ?
                                                                    <span className='badge badge-pill badge-primary bg-success mx-2 text-small-3 '>
                                                                    نقدی
                                                                </span> :
                                                                    <span className='badge badge-pill badge-primary bg-danger mx-2 text-small-3 '>
                                                                    چکی
                                                                </span>

                                                            }
                                                        </div>
                                                        {
                                                            status === 3 && order.vendor_score < 1 &&
                                                            <div className='mt-2'>
                                                          <span className='btn btn-warning text-small-2'>
                                                              <FaRegStar className='mx-2 '/>
                                                                ثبت امتیاز به عملکرد مشتری
                                                          </span>
                                                            </div>
                                                        }

                                                        {
                                                            order.vendor_score > 0 &&
                                                            <div className='d-flex justify-content-center mt-2'>
                                                                <StarRating score={order.vendor_score} />
                                                            </div>
                                                        }


                                                    </td>
                                                    <td>
                                                        {order.address.address}

                                                    </td>
                                                    <td>
                                                        {order.date}
                                                    </td>
                                                    <td>
                                                        {order.tracking_code}
                                                    </td>

                                                    <td>
                                                        {
                                                            order.cash_discount_percent > 0 ?
                                                                currencyFormat.format(order.pay_amount * ( 1 - (order.cash_discount_percent / 100)))
                                                                :
                                                                currencyFormat.format(order.pay_amount)
                                                        }
                                                        &nbsp;
                                                        ریال
                                                    </td>
                                                </tr>
                                            )} )
                                    }


                                    </tbody>
                                </table>

                            </div>
                            <div className="col-12">
                                {orders.length < 1 &&
                                <div className="alert alert-secondary text-small-1 text-center">
                                    <IoWarningOutline className='text-big-5 mx-3' />

                                    سفارشی پیدا نشد
                                </div>

                                }
                            </div>
                        </div>

                    </div>
                </div>
            </section>
        </React.Fragment>
    );
}

export default Home;